import { useMutation } from '@tanstack/react-query';
import {
  IPAContentEventParams,
  onDonePAContent,
} from '../../queries/DailySchedule/scheduleContent';

export function useDoneLesson() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (params: IPAContentEventParams) => onDonePAContent(params),
  });

  return {
    mutateAsync,
    isPending,
  };
}
